import ElemseeTestimonial from "@/src/features/onboarding/components/ElemseeTestimonial";
import clsx from "clsx";

const WelcomeStep = ({ stepData }: any) => {
  const heading = stepData?.heading;

  return (
    <div
      className={clsx(
        "WelcomeStep",
        "flex h-full w-full flex-col items-start justify-start lg:flex-row"
      )}
    >
      <div className="flex flex-col bg-white text-black">
        <div className="flex flex-1 flex-col justify-center space-y-6 lg:space-y-12">
          <h1
            className="text-balance font-spatial text-3xl font-medium md:pt-5 md:text-5xl"
            data-posthog="onboarding-welcome-heading"
          >
            {heading}
          </h1>

          <ElemseeTestimonial />
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep;
